export default function initTabs() {
    const $blocksTabs = document.querySelectorAll<HTMLElement>('.js-tabs');
    $blocksTabs.forEach($container => {
        new Tabs($container);
    });
}

/**
 * @param {HTMLElement} $el           HTML Element Block nos offres
 */
class Tabs {
    $el: HTMLElement | null | undefined;
    $tabs: NodeListOf<HTMLElement> | null | undefined;
    $tabsButtons: NodeListOf<HTMLElement> | null | undefined;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$tabsButtons = $el?.querySelectorAll('[data-tab]');
        this.$tabs = $el?.querySelectorAll('[data-tab-target]');

        this.init();
    }

    /**
     * Initialise les onglets
     */
    init() : void {
        if (!this.$el || !this.$tabsButtons || !this.$tabs) return;

        // Ajout des rôles et attributs ARIA
        this.$el.querySelector('.tabs-nav')?.setAttribute('role', 'tablist');

        this.$tabsButtons.forEach((button, i) => {
            const dataTab = button.getAttribute('data-tab') || `tab-${i}`;
            const tabId = dataTab;
            const panelId = `tabpanel-${dataTab}`;
            button.setAttribute('role', 'tab');
            button.setAttribute('id', tabId);
            button.setAttribute('aria-controls', panelId);
            button.setAttribute('tabindex', button.classList.contains('active') ? '0' : '-1');
            button.setAttribute('aria-selected', button.classList.contains('active') ? 'true' : 'false');
        });

        this.$tabs.forEach((tab, i) => {
            const button = this.$tabsButtons?.[i];
            const dataTab = button?.getAttribute('data-tab') || `tab-${i}`;
            const tabId = dataTab;
            const panelId = `tabpanel-${dataTab}`;
            tab.setAttribute('role', 'tabpanel');
            tab.setAttribute('id', panelId);
            tab.setAttribute('aria-labelledby', tabId);
            if (!tab.classList.contains('active')) {
                tab.setAttribute('hidden', 'true');
            } else {
                tab.removeAttribute('hidden');
            }
        });

        // Gestion du clic
        this.$tabsButtons.forEach((button, i) => {
            button.addEventListener('click', () => {
                this.$tabsButtons?.forEach((btn) => {
                    btn.classList.toggle('active', btn === button);
                    btn.setAttribute('aria-selected', btn === button ? 'true' : 'false');
                    btn.setAttribute('tabindex', btn === button ? '0' : '-1');
                });
                this.$tabs?.forEach((tab, j) => {
                    if (i === j) {
                        tab.classList.add('active');
                        tab.removeAttribute('hidden');
                    } else {
                        tab.classList.remove('active');
                        tab.setAttribute('hidden', 'true');
                    }
                });
                button.focus();
            });

            // Gestion du clavier (flèches gauche/droite)
            button.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const buttons = Array.from(this.$tabsButtons!);
                    let idx = buttons.indexOf(button);
                    if (e.key === 'ArrowRight') {
                        idx = (idx + 1) % buttons.length;
                    } else {
                        idx = (idx - 1 + buttons.length) % buttons.length;
                    }
                    buttons[idx].focus();
                }
            });
        });
    }
}
